export default __webpack_public_path__ + "ZurichMedicalProvidersBahrainAndQatar.pdf";